import {Img} from '@react-email/components'
import {preferences} from "@/config";

export const ComponentEmailLogo = () => {
    return (
        <Img src={`https://${preferences.domainName}/images/logo-header.png`} width={110} height={100} alt={""} />
    )
}